import { loadFullBody } from '../actions/loadFullBody';
import { updateCachedItemBodies, updateIsLoadingFullBody } from '../mutators/loadFullBodyMutators';
import getItem from 'owa-mail-store/lib/services/getItem';
import checkIfResponseSuccess from 'owa-mail-store/lib/services/utils/checkIfResponseSuccess';
import mailStore from 'owa-mail-store/lib/store/Store';
import { getBaseItemResponseShape } from 'owa-mail-store/lib/utils/getItemResponseShape';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import { orchestrator } from 'satcheljs';

export default orchestrator(loadFullBody, async actionMessage => {
    const { viewState } = actionMessage;
    const itemId = viewState.itemId;
    updateIsLoadingFullBody(viewState, true);

    const item = mailStore.items.get(itemId);

    const itemShape = getBaseItemResponseShape();

    // Plan to fetch UniqueBody for an itemPart.
    let shapeName = 'ItemPart';

    if (!item.UniqueBody) {
        // If we don't have a UniqueBody, change the shapeName to get the NormalizedBody instead.
        shapeName = 'ItemNormalizedBody';
    } else if (item.NormalizedBody) {
        // If we have both, request NormalizedBody as an additionalProperty.
        itemShape.AdditionalProperties.push(propertyUri({ FieldURI: 'NormalizedBody' }));
    }

    itemShape.MaximumBodySize = 0;

    const response = await getItem([itemId], itemShape, shapeName);
    if (mailStore.items.get(itemId) && checkIfResponseSuccess(response[0])) {
        const responseItem = response[0] as ItemInfoResponseMessage;

        updateCachedItemBodies(item, responseItem.Items[0]);

        updateIsLoadingFullBody(viewState, false);
    }
});
